"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ready;

function ready(fn) {
  if (document.readyState !== 'loading') {
    fn();
    return;
  }

  document.addEventListener('DOMContentLoaded', function (event) {
    fn();
  });
}